import gql from "graphql-tag";

const IconsQuery = gql`
  query icons(
    $page: Int
    $pageSize: Int
    $sortField: String
    $sortOrder: String
    $search: String
    $categoryId: Int
  ) {
    icons(
      paginate: { page: $page, pageSize: $pageSize }
      sort: { field: $sortField, order: $sortOrder }
      search: $search
      categoryId: $categoryId
    ) {
      entries {
        id
        name
        imageData
        createdAt
        updatedAt
      }
      currentPage
      pageSize
      pagesCount
      entriesCount
    }
  }
`

export default IconsQuery;